export const CUSTOM_PROFANITY_STEMS = Object.freeze([
  'fuck',
  'cunt',
  'nigger',
  'coon',
  'paki',
  'motherfuck',
  'fag',
  'faggot',
  'kike',
  'spic',
  'wetback',
  'retard',
  'pedophil',
  'paedophil',
  'necrophil',
  'bestial',
]);

// Exact terms are useful when you want to block a whole word without also
// blocking longer innocent compounds. Example: "rape" should not catch
// "rapeseed"
export const CUSTOM_PROFANITY_EXACT_TERMS = Object.freeze([
  'rape',
  'raped',
  'raper',
  'rapers',
  'rapes',
  'rapee',
  'rapey',
  'rapist',
  'rapists',
  'tranny',
  'trannies',
  'nig',
  'nigs',
  'nigga',
  'niggas',
  'fuk',
  'fuks',
  'fucc',
  'fucca',
  'fuccboi',
  'fuccboy',
  'pedo',
  'pedos',
  'paedo',
  'paedos',
]);
